import { config } from './config';
import loggerHelper from './loggerHelper';

/**
 * Send email through MGenie mail API (used by static site; no MailerSend key in browser).
 */
export const sendMailRequest = async ({
    subject,
    summary,
    customerName,
    customerEmail,
    businessName,
    phone,
    inquiryType,
}) => {
    if (!subject || !summary) {
        throw new Error('Subject and message are required');
    }

    const endpoint = `${config.mailApiBaseUrl}/api/mail/website-request`;

    loggerHelper.info('Sending mail via MGenie API', {
        subject,
        inquiryType: inquiryType || null,
        businessName: businessName || null,
    });

    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            subject,
            summary,
            customerName: customerName || undefined,
            customerEmail: customerEmail || undefined,
            businessName: businessName || undefined,
            phone: phone || undefined,
            inquiryType: inquiryType || undefined,
        }),
    });

    let payload = null;
    try {
        payload = await response.json();
    } catch (error) {
        payload = null;
    }

    if (!response.ok || !payload?.ok) {
        const message = payload?.message || 'Could not send your message. Please try again.';
        loggerHelper.error('MGenie mail API failed', {
            status: response.status,
            payload,
        });
        const sendError = new Error(message);
        sendError.details = payload?.details || null;
        sendError.status = response.status;
        throw sendError;
    }

    return {
        messageId: payload.messageId || null,
        payload,
    };
};

export const buildContactSummary = ({
    inquiryType,
    serviceTitle,
    customerName,
    customerEmail,
    phone,
    businessName,
    message,
}) => {
    return [
        'DEVCRAFT CONTACT REQUEST',
        '========================',
        `Submitted: ${new Date().toLocaleString('en-IN')}`,
        `Type: ${inquiryType || 'General'}`,
        `Related to: ${serviceTitle || 'General'}`,
        '',
        `Name: ${customerName || '—'}`,
        `Email: ${customerEmail || '—'}`,
        `Phone / WhatsApp: ${phone || '—'}`,
        `Business: ${businessName || '—'}`,
        '',
        'Message:',
        message || '—',
    ].join('\n');
};
